<template>
  <section :class="$style.container" data-luko-tracking="SimpleSlice">
    <Wrapper :class="$style.inner">
      <div
        :class="[
          [$style.content],
          { [$style.isReverse]: content.image_position || false },
        ]"
      >
        <div :class="$style.view">
          <PImage
            loading="lazy"
            :image-object="content.image"
            :class="$style.image"
            size="xs:100vw"
            :quality="80"
          />
        </div>
        <div :class="$style.desc">
          <RichText
            v-if="content.title"
            :text-params="content.title"
            :class="$style.title"
          />
          <RichText
            v-if="content.text"
            :text-params="content.text"
            :class="$style.text"
          />
          <CtaBox :item="content" />
        </div>
      </div>
    </Wrapper>
  </section>
</template>

<script>
import RichText from '~/components/RichText'
import PImage from '~/components/PImage'
import CtaBox from '~/components/CtaBox'

export default {
  name: 'SimpleSlice',

  components: {
    RichText,
    PImage,
    CtaBox,
  },

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      content: this.slice.primary,
    }
  },
}
</script>

<style lang="scss" module>
.container {
  padding: 78px 24px;

  background-color: #fffbf2;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 32px;

  @include above(small) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    &.isReverse {
      flex-direction: row-reverse;
    }
  }

  @include above(small) {
    column-gap: 32px;
  }
  @include above(large) {
    column-gap: 40px;
  }
}

.desc {
  flex-basis: 0;
  flex-grow: 1;

  a {
    margin-top: 40px;
  }

  @include above(small) {
    margin-top: 0;
  }
  @include above(medium) {
    padding: 0 73px;
  }
}

.view {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 620px;

  img {
    display: block;
    width: 100%;
  }

  @include above(medium) {
    flex-basis: 15%;
  }
}

.image {
  border-radius: 8px;
}

.title {
  @include typo-large-title;
}
.text {
  @include typo-body;
  margin-top: 16px;

  color: $gray-700;
}
</style>
